import { useEffect } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";

interface UseEntityBrowseOptions<TSearch extends FieldValues> {
  form: UseFormReturn<TSearch>;
  sortKey: string;
  sortMethod: string;
  onSearch: (values: TSearch) => void;
}

/**
 * Shared browse wiring for tickets/documents search pages.
 * Keeps behavior identical to existing watch+submit flows.
 */
export function useEntityBrowse<TSearch extends FieldValues>({form, sortKey, sortMethod, onSearch}: UseEntityBrowseOptions<TSearch>) {

  useEffect(() => {
    if (sortKey && sortMethod) {
      form.handleSubmit(onSearch)();
    }
  }, [sortKey, sortMethod]);

  useEffect(() => {
    const subscription = form.watch(() => {
      form.handleSubmit(onSearch)();
    });

    return () => subscription.unsubscribe();
  }, [form]);
}
